import { useState } from "react";
import { Confirmacao } from "@/components/ui/Confirmacao";

/**
 * Delete button with a confirmation modal.
 *
 * The prop changed shape: it used to take a Server Action
 * `(formData) => Promise<void>` and submit a hidden form via `requestSubmit()`.
 * Now it takes `(id) => Promise<unknown>` and calls it directly — no hidden
 * form, no FormData round-trip. The modal and every class name are unchanged.
 */
export function BotaoApagar({
  accao,
  id,
  etiqueta = "Apagar",
  confirmacao = "Esta ação não pode ser desfeita.",
  titulo = "Apagar?",
}: {
  accao: (id: string) => Promise<unknown>;
  id: string;
  etiqueta?: string;
  confirmacao?: string;
  titulo?: string;
}) {
  const [aberto, setAberto] = useState(false);
  const [aApagar, setAApagar] = useState(false);

  async function confirmar() {
    setAberto(false);
    setAApagar(true);
    try {
      await accao(id);
    } finally {
      setAApagar(false);
    }
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setAberto(true)}
        disabled={aApagar}
        className="rounded-full border border-blush/60 px-4 py-2 text-sm font-semibold text-tinta/80 transition-colors hover:border-blush hover:bg-blush-300/30 hover:text-tinta disabled:opacity-60"
      >
        {aApagar ? "A apagar…" : etiqueta}
      </button>

      <Confirmacao
        aberto={aberto}
        titulo={titulo}
        mensagem={confirmacao}
        textoConfirmar="Apagar"
        destrutivo
        onCancelar={() => setAberto(false)}
        onConfirmar={() => void confirmar()}
      />
    </>
  );
}
